export default {
    path: ":alias/brands/artremark",
    component: resolve => require(["@/views/art-remark"], resolve),
    children: [
      {
        path: "list",
        component: resolve => require(["@/views/art-remark/list"], resolve)
      }
    ]
  };
  